export var makeFormLabelStyles = function makeFormLabelStyles(_ref) {
  var tokens = _ref.tokens;
  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: tokens.colors["ink-on-background"]
          },
          "&.Mui-disabled": {
            color: tokens.colors["ink-on-background"]
          }
        },
        asterisk: {
          display: "none"
        }
      }
    }
  };
};